import Vue from 'vue';
import {kFormatter} from '../helpers/helpers';

Vue.filter('kFormatter',  (num) => {
  return kFormatter(num);
});

Vue.filter('currency', (num) => {
  return (num/1).toFixed(2).toString();
})



// WEBPACK FOOTER //
// ./src/filters/index.js